module.exports = __webpack_public_path__ + "media/images/lightbulb_icon-a07e3f84.png";